// initRebranding has to run first
// this allows us to call setRebrandingEnabled() from system/ui-theme before the theme is created
import "./initRebranding";
import "./global.scss";
import "./polyfills";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { createRoot } from "react-dom/client";

import App from "./app/app";
import { AppRemountProvider, useAppRemount } from "./appV2/context/AppRemountContext";
import { TimersProvider } from "./appV2/lib/utils/useTimers";

function AppWrapper() {
  const { remountKey } = useAppRemount();
  return <App key={remountKey} />;
}

function Root() {
  return (
    <AppRemountProvider>
      {/* TimersProvider sits outside AppWrapper so timers survive an AppRemount (TEM-2002). */}
      <TimersProvider>
        <AppWrapper />
      </TimersProvider>
    </AppRemountProvider>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root is not found");
}
const root = createRoot(container);
root.render(<Root />);

void defineCustomElements(window);
